export const sortByField = (headerKeyActive, isDown, dataName) =>{
  return{
    type: 'SORT_BY_FIELD',
    headerKeyActive,
    isDown,
    dataName
  }
}

export const duplicateData = (dataName) =>{
  return{
    type: 'DUPLICATE_DATA',
    dataName
  }
}

export const filterData = (filter, dataName, removeFilter) =>{
  return{
    type: 'FILTER_DATA',
    filter,
    dataName,
    removeFilter
  }
}

export const editData = (changedDataObj, dataName) => {
  return{
    type: 'EDIT_DATA',
    changedDataObj,
    dataName
  }
}

export const deleteData = (objID, dataName) => {
  return{
    type: 'DELETE_DATA',
    objID,
    dataName
  }
}

export const addData = (dataName) =>{
  return{
    type: 'ADD_DATA',
    dataName
  }
}